import { Button } from "@mui/material";
import React from "react";

export const MyButton = (props) => {
  return (
    <Button
      aria-label={props.text}
      disabled={props.disabled != null ? props.disabled : false}
      className={props.className}
      style={{ marginTop: "1rem", ...props.style }}
      onClick={props.onClick}
      // color={props.color ?? "primary"}
      variant={props.buttonVariant ? props.buttonVariant : "contained"}
    >
      <span className="text">{props.text}</span>
    </Button>
  );
};
